import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dirty-form"
export default class extends Controller {
  static values = {
    message: {
      type: String,
      default: "You have unsaved changes. Are you sure you want to leave?"
    }
  }

  connect() {
    this.submitting = false
    this.initialState = this.serialize()

    this.beforeUnload = this.beforeUnload.bind(this)
    this.beforeVisit = this.beforeVisit.bind(this)
    this.submitStart = this.submitStart.bind(this)
    this.submitEnd = this.submitEnd.bind(this)

    window.addEventListener("beforeunload", this.beforeUnload)
    document.addEventListener("turbo:before-visit", this.beforeVisit)

    this.element.addEventListener("turbo:submit-start", this.submitStart)
    this.element.addEventListener("turbo:submit-end", this.submitEnd)
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.beforeUnload)
    document.removeEventListener("turbo:before-visit", this.beforeVisit)

    this.element.removeEventListener("turbo:submit-start", this.submitStart)
    this.element.removeEventListener("turbo:submit-end", this.submitEnd)
  }

  get isDirty() {
    return this.initialState !== this.serialize()
  }

  serialize() {
    const data = [...new FormData(this.element).entries()]

    // remove blank file inputs to avoid false positives
    const normalized = data.filter(([_, value]) => {
      return !(value instanceof File && value.size === 0)
    })

    return JSON.stringify(normalized)
  }

  beforeUnload(event) {
    if (!this.isDirty || this.submitting) return

    event.preventDefault()
    event.returnValue = this.messageValue
  }

  beforeVisit(event) {
    if (!this.isDirty || this.submitting) return

    if (!confirm(this.messageValue)) {
      event.preventDefault()
    }
  }

  submitStart() {
    this.submitting = true
  }

  submitEnd(event) {
    this.submitting = false

    if (event.detail.success) {
      this.initialState = this.serialize()
    }
  }
}